import { STATUS_CLASSES } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { stLabel } from "@/lib/txnI18n";

export function StatusBadge({ status }) {
  const { lang } = useI18n();
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium uppercase tracking-wider ${STATUS_CLASSES[status] || ""}`}
    >
      {stLabel(status, lang)}
    </span>
  );
}
